import Modal from './InModal'
 function install(Vue) {
    if (install.installed) return 
    install.installed = true
    Object.defineProperty(Vue.prototype, '$vModal', {
        get() { return Modal }
      })
}

export default install